

<template>
    <div class="footer-banner">
        <div class="footer-banner-swiper">
            <swiper
                :slides-per-view="1"
                :space-between="50"
                :pagination="{ clickable: true }"
                 :autoplay="{ delay: 5000 }"
                @swiper="onSwiper"
                @slideChange="onSlideChange"
            >
                <swiper-slide v-for="item in items" :key="item.key">
                    <div class="footer-banner-swiper-component">
                        <div class="footer-banner-swiper-banner" >
                            <img src="../assets/img/student-testimonial001.png" />
                        </div>
                        <div class="footer-banner-swiper-content" >
                            <div class="footer-banner-swiper-content-description" >
                                This course is what I have been looking for. The instructors are very clear and don’t speak too fast. Conversations and phrases with grammar explanations, plus the pinyin and character subtitles are very helpful.
                            </div>
                            <div class="footer-banner-swiper-content-name" >
                                Jualina
                            </div>
                            <div class="footer-banner-swiper-content-date" >
                                Feb 17, 2021
                            </div>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
        <div class="footer-banner-divider">
            <img class="footer-banner-pc" src="../assets/img/ata-line.png">
            <img class="footer-banner-mobile" src="../assets/img/mobile/ata-line.png">
        </div>
        <div class="footer-banner-content">
            Ready to Learn Mandarin Chinese?
            <div class="footer-banner-content-description">
               Sign up and try our online courses
            </div>
            <router-link to="/login">
                <el-button>
                    Enroll Now
                </el-button>
            </router-link>
        </div>
    </div>
</template>

<script>
import SwiperCore, { Autoplay, Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper.scss';
import 'swiper/components/pagination/pagination.scss';

SwiperCore.use([Autoplay, Pagination, A11y]);


export default {
    name: 'FooterBanner',
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            items: 6,
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {},
         onSwiper(swiper) {
            console.log(swiper);
        },
        onSlideChange() {
            console.log('slide change');
        },
    },
}
</script>

<style lang="scss">
    @import "../styles/pc/FooterBanner.scss";
    @import "../styles/mobile/FooterBanner.scss";
</style>
